module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/axios/index.js
// module id = 66
// module chunks = 0 1 2 3 4 5 6